export const SLOT_QUERY_PARAM_KEY = 'slot';

export const Slot = {
  ACTION: 0,
  PAY: 1,
  POST_PAY: 2,
  SETTINGS: 3,
  UI: 4,
  VERIFY_CUSTOMER: 5,
};

export const SlotQueryParamValues = {
  ACTION: 'action',
  PAY: 'pay',
  POST_PAY: 'postpayment',
  SETTINGS: 'settings',
  VERIFY_CUSTOMER: 'verifycustomer',
};
